import { API_BASE_URL } from '../config';

// A failed fetch() call (offline, DNS failure, server unreachable, CORS) throws
// a raw browser TypeError like "Failed to fetch" with no response at all. That's
// distinct from the server responding with an error status, so it's translated
// to friendly copy here rather than surfaced verbatim to the user.
function networkErrorMessage() {
  return navigator.onLine === false
    ? 'No internet connection. Please check your network and try again.'
    : 'Could not reach the server. Please check your connection and try again.';
}

export async function login(mobile, password) {
  const body = new URLSearchParams({ username: mobile, password });
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body,
    });
  } catch (err) {
    throw new Error(networkErrorMessage());
  }

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const error = new Error(data.detail || 'Invalid mobile number or password');
    error.status = response.status;
    throw error;
  }

  return response.json();
}

export async function fetchCurrentUser(token) {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/users/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (err) {
    throw new Error(networkErrorMessage());
  }

  if (!response.ok) {
    const error = new Error(response.status === 401 ? 'Session expired' : `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }

  return response.json();
}
